export default "__VITE_ASSET__BImy793b__"